<template>
    <div class="corpo-etapa">
        <div class="itens-da-etapa">
            <!-- <h3>{{ etapa.nome }}</h3> -->
            <h4 style="padding: 10px;" :class="classQtdMax">Selecione a {{ isBorda ? 'borda' : 'massa' }}</h4>


            <!-- bordas ou massas -->
            <div class="div-lista-bordas-massas">
                <div v-for="(item, index) in etapa" :key="index">
                    <div :class="produtoSelecionado.codigo  == item.codigo?'item-card select':'item-card not-select'" @click="selecionouItem(item)">
                            <p>{{ item.descricaoCompleta }}</p>
                            <p style="margin-top: 15px;">{{ converterValorVendaEmStr(valorMostrar(item)) }}</p>
                    </div>
                </div>
            </div>
                

            <div class="div-botao-avancar">
                <button v-if="podeAvancar" class="botao botao-avancar" @click="avancar"> 
                    <img class="icon-check" src="../../../../assets/icons/ic-check.png" alt="">
                    Avançar</button>
                <button v-if="!podeAvancar" class="botao botao-desativado">Avançar</button>
            </div>
        </div>
    </div> 
</template>

<script>

export default {
    name: "BordaEMassa",
    props: {
        indexEtapaCorrente: Number,
        totalEtapas: Number,
        etapa: Array,
        isBorda: Boolean
    },

    computed: {
        podeAvancar() {
            if ( this.produtoSelecionado.codigo != null || this.isBorda) {
                return true
            }
            return false
        },
    },
    watch: {
        isBorda() {
            this.produtoSelecionado = {}
        }
    },
    data() {
        return {
            classQtdMax: 'qtd-max',
            produtoSelecionado: {},
        };
    },
    methods: {

        valorMostrar(item) {
            if (item.valorPromocao != null && item.valorPromocao != 0.0) {
                return item.valorPromocao
            }
            return item.valorVenda
        },

        converterValorVendaEmStr(valor) {
            let valorFixed = valor.toFixed(2).replace(".", ",")
            return "R$ " + valorFixed
             
        },


        /**
         * Verificar se o item é mercadoria ou produto
         * @param {*} item
         */
        selecionouItem(item) {
            if(this.produtoSelecionado===item){//vamos usar para tirar a seleção da borda
                this.produtoSelecionado = [];
            }
            else{
                this.produtoSelecionado = item
            }
        },

        computarAdicionais() {
            
        },



        /**
         * Enviar para o parent o item selecionado
         * @param {*} item
         */
        avancar() {

            if (this.podeAvancar) {

                const itemFinalizado = {
                    podeAvancar: this.podeAvancar,
                    id: this.produtoSelecionado.codigo,
                    codigo: this.produtoSelecionado.codigo,
                    nome: this.produtoSelecionado.descricaoCompleta,
                    preco: this.valorMostrar(this.produtoSelecionado), 
                    precoApenasVariacoes: this.valorMostrar(this.produtoSelecionado),
                    valorUnitarioPagoNoSmartPos: this.valorMostrar(this.produtoSelecionado),
                    fichaTecnica: null,
                    quantidade: 1,
                    retirar: null,
                    adicionar: null,
                    perguntasForcadas: null,
                    precoTotal:this.valorMostrar(this.produtoSelecionado),
                }

                if (this.isBorda) {
                    this.$emit("onSelectedBorda", itemFinalizado);
                } else {
                    this.$emit("onSelectedMassa", itemFinalizado);
                }
            }
        },
    },
    components: {   }
}
</script>

<style scoped>
.corpo-etapa > .itens-da-etapa{
    background: white;
    /* min-height: 70vh; */
}
h4{
    color: black;
}

.select{
    border: solid 2px var(--verde-claro);
    background: var(--verde-claro);
    color: white;
}
.not-select{
    border: solid 2px var(--cor1-escura);
    background: whitesmoke;
    color: black;
}

.div-lista-bordas-massas{
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    min-height: 60vh;
    padding: 15px;
    box-sizing: border-box;
    align-content: flex-start;
    justify-content:space-between;
}
.item-card{
    padding-block: 15px;
    width: 150px;
    border-radius: 5px;
    box-sizing: border-box;
}


.div-botao-avancar{
    padding-bottom: 15px;
    margin: 15px;
}
.botao{
    width: 100%;
    height: 50px;
    border-radius: 5px;
    font-weight: bold;
    display:flex;
    align-items: center;
    justify-content: center;
}
.botao-avancar{
    background: var(--gradiente-verde);
}
.botao-desativado{
    background: var(--gradiente-desabilitado);
}
.icon-check{
    height: 25px;
    width: 25px;
    left: 30%;
    position: absolute;
    filter: invert(100%);
}

</style>